export default __webpack_public_path__ + "static/media/gallery_15.ff747923.jpg";